import { Component, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { alertService } from '@app/modules/common/alert';
import { languageService, languageSupport } from '@app/modules/common/language';
import { viewService } from '@app/modules/view';

import { Place } from '@app/modules/model/place';
import { PlaceArea } from '@app/modules/model/placearea';
import { PlaceService } from '@app/modules/model/svcplace';
import { Extra } from '@app/modules/model/extra';
import { QrCode } from '@app/modules/model/qrcode';

/************************************/
/* USER COMPONENT                   */
/************************************/

@Component({
    selector: 'ui-table-select',
    templateUrl: 'ui-select.html',
    styleUrls: [
      'ui-select.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiTableSelect extends languageSupport implements OnInit, OnChanges, OnDestroy {    
    @Input('place') _place: Place = null; 
    @Input('extra') _extra: Extra = null;
    @Input('area') _area: PlaceArea = null;
    @Input('till') _till: PlaceService = null;
    @Input('tables') _tables: Array <QrCode> = [];

    get Parent(){
        if (this._extra){
            return 'extra';
        }

        if (this._area){
            return 'area';
        }

        if (this._till){
            return 'till';
        }

        return null;
    }

    private _selected: Array <QrCode> = [];
    private _pristine: boolean = true;

    IsChecked(_qrcode){
        return (this._selected.indexOf(_qrcode) != -1);
    }

    get Selected(){
        return this._selected;
    }

    private _viewtables = null;
    get Tables() {;
        if (this._viewtables == null){
            let _tables = [];
            for(let _table of this._place.tables){
                if (_table.IsValid){
                    _tables.push(_table);
                }
            }
            this._viewtables = _tables;
        }

        return this._viewtables;        
    }

    /**********************************/
    /* TABLES SELECTION               */
    /**********************************/

    @ViewChild('container', {static: false}) _container: ElementRef;

    constructor(private lang: languageService, private change: ChangeDetectorRef, private alertCtrl: alertService, public view: viewService) {
        super(lang, change);
    }

    private _place_subscription = null;

    ngOnInit(){
        this._place_subscription = this._place.OnTargetRefresh('QRCODE').subscribe(
        data => {
            this._viewtables = null;
            this.change.markForCheck();
        });
    }

    ngOnChanges(){
        this._selected = this._tables ? this._tables.slice(0) : [];
    }

    ngOnDestroy(){
        super.OnDestroy();

        if (this._place_subscription){
            this._place_subscription.unsubscribe();
            this._place_subscription = null;
        }
    }

    @Output('onAccept') _onAccept = new EventEmitter<any>();     
    OnAccept(){
        this._onAccept.emit(this._selected);
    }

    @Output('onCancel') _onCancel = new EventEmitter<any>();     
    async OnCancel(){
        if (!this._pristine){
            console.log("[EDIT QRCODES] confirm changes lost");
            const alert = this.alertCtrl.alert({
                header: this.lang.tr('@changes_lost_confirm_tittle'),
                message: this.lang.tr('@changes_lost_confirm_message'),
                backdropDismiss: false,
                buttons: [{
                    text: this.lang.tr('@yes'),
                    handler: () => {
                        setTimeout(() => {
                            alert.dismiss(true);
                        }, 100);

                        return false;
                    }
                }, {
                    text: this.lang.tr('@no'),
                    handler: () => {
                        setTimeout(() => {
                            alert.dismiss(false);
                        }, 100);
                        return false;
                    }
                }]
            });

            alert.onDidDismiss().then((detail:any) => {
                if (detail.data == true){
                    this._onCancel.emit();
                }
            });

            await alert.present();
        }
        else {
            this._onCancel.emit();
        }
    }

    /* thumbnail actions */

    OnSelect(_table){
        let _idx = this._selected.indexOf(_table);
        if (_idx == -1){
            this._selected.push(_table);
        }
        else {
            this._selected.splice(_idx, 1);
        }

        this._pristine = false;
        this.change.markForCheck();
    }
}